
// import React, { useState, useEffect } from 'react'
// import sidebarmenus from '../routes/routes';
// import { useLocation } from 'react-router-dom';
// import NotificationBell from '../components/common/Notifications/NotificationBell';
// import DropDownButton from '../components/common/HeaderDropdownMenus/DropDownButton';
// import HeaderUserName from '../components/common/HeaderUserName';
// // import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
// // import { httpinstance } from '../axios/api';
// // import { useDispatch } from 'react-redux';
// // import { setSelectedBranchId as setBranchInRedux } from '../store/Newslices/branchSlice';

// const Header = () => {
//     // const dispatch = useDispatch();
//     const [pageTitle, setPageTitle] = useState('')
//     // const [selectedBranchId, setSelectedBranchId] = useState('')
//     // const [casscodedata, setCasscodedata] = useState([])
//     const path = useLocation()
//     const user_name = JSON.parse(localStorage.getItem("user"));
//     // const allowed_branch_id=(localStorage.getItem("allowed_branch_id"))
//     // const allowedbranchname=(localStorage.getItem("branch_name"))
//     useEffect(() => {
//         function getheadertitle(name) {
//             return sidebarmenus?.find((item) => `/${item?.path}` === name);
//         }
//         const headername = getheadertitle(path?.pathname);
//         headername ? setPageTitle(headername?.name) : setPageTitle('')
//     }, [path])

//     // // ✅ Fetch branch/cass details on mount
//     // const fetchCassDetails = async () => {
//     //         try {
//     //             const response = await httpinstance.post('/cass-details', {
//     //                 cass_ids: allowedbranchname?.match(/\d+/g)?.map(Number),
//     //             });
//     //
//     //             const list = response?.data?.data?.data;

//     //             if (list && list.length > 0) {
//     //                 setCasscodedata(list);
//     //                 setSelectedBranchId(list[0]?.id);
//     //                 dispatch(setBranchInRedux(list[0]?.id));
//     //             }
//     //         } catch (error) {
//     //             console.error('Failed to fetch cass details:', error);
//     //         }
//     //     };
//     // useEffect(() => {
//     //
//     // if(allowedbranchname.length>0){
//     //         fetchCassDetails();}
//     // }, []);

//     // const handleChange = (e) => {
//     //     setSelectedBranchId(e.target.value);
//     //     dispatch(setBranchInRedux(e.target.value));
//     // }

//     return (
//         <div className='bg-white shadow-cardsection rounded-xl w-full p-5'>
//             <div className="flex items-center justify-between">
//                 <div className="flex items-center">
//                     {
//                         pageTitle &&
//                         <p className='mx-5 font-bold text-lg leading-5 text-secondary'>{pageTitle}</p>
//                     }
//                 </div>

//                 <div className="flex items-center gap-5">
//                     {/* Branch selector disabled
//                     <FormControl sx={{ m: 1, minWidth: 120 }} size="small" disabled={path?.pathname === '/search-rates/search-rates-result'}>
//                         <InputLabel id="demo-select-small-label">Branch</InputLabel>
//                         <Select
//                             labelId="demo-select-small-label"
//                             id="branch-select"
//                             value={selectedBranchId}
//                             label="Branch"
//                             onChange={handleChange}
//                             sx={{
//                                 fontSize: { xs: '12px', sm: '14px' },
//                             }}
//                         >
//                             {casscodedata?.map((item, index) => (
//                                 <MenuItem key={index} value={item?.id}>
//                                     {item?.branch_name}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                     */}
//                     <HeaderUserName user_name={user_name} />
//                     <NotificationBell />
//                     <DropDownButton user_name={user_name} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Header


import React, { useState, useEffect } from 'react'
import sidebarmenus from '../routes/routes';
import { useLocation, NavLink } from 'react-router-dom';
import NotificationBell from '../components/common/Notifications/NotificationBell';
import DropDownButton from '../components/common/HeaderDropdownMenus/DropDownButton';
import HeaderUserName from '../components/common/HeaderUserName';
import logo from '../assets/images/asap_logo.png';
import { ACL_ROUTE } from '../utils/constant';
import { useSelector, useDispatch } from 'react-redux';
import { clearOceanSearchForm } from '../store/SearchRates/SearchRatesSlice';
import { clearStoredSearch } from '../store/Newsearchform/Newsearchform';
import { clearnewqueries } from '../store/Newsearchform/Newqueries';
import { authuser } from '../store/Authentication/AuthSlice';

const Header = () => {
    const [pageTitle, setPageTitle] = useState('')
    const path = useLocation()
    const dispatch = useDispatch();
    const user_name = useSelector(authuser);

    const data = useSelector((state) => state?.data?.data?.data?.user?.userroles);
    // "/search-rates" stays in ACL_ROUTE.kam so the ocean results page's
    // "Edit Query" (a deep-link back into an already-established customer
    // query, not a standalone search) keeps working — but a KAM shouldn't be
    // able to just click into a blank search from the nav, so it's excluded
    // here specifically, without touching route registration.
    const getAuthorizedRoutes = sidebarmenus
      .filter((route) => ACL_ROUTE[data]?.includes(route.path))
      .filter((route) => !(data === "kam" && route.path === "/search-rates"));

    // Determine which top-bar menu is currently active. Handles all cases:
    // leading/trailing slashes, exact match, and nested/child routes
    // (e.g. /search-rates/search-rates-result should keep "Search Rates" active).
    const normalize = (p) => `/${(p || '').replace(/^\/+|\/+$/g, '')}`;
    const currentPath = normalize(path.pathname);

    // A booking-detail page lives UNDER /booking-history/* but is reachable from
    // two different lists, so the path alone can't say which nav item the user
    // is "inside": opening a booking from Queries lit up "Bookings" even though
    // the user never left the Queries section (and the page's own back button
    // returns there). The list that opened it stamps `?from=` on the URL — see
    // handleAirBookingView in pages/Admin/Queries.jsx — so honour that over the
    // path whenever it's present.
    //
    // Both queries paths are listed because the role decides which one exists:
    // /queries for customers, /QueriesKAM for kam/air_admin. Only the role's own
    // entry survives the ACL filter above, so this can never light up two items.
    const FROM_MENU_PATHS = {
        queries: ['/queries', '/QueriesKAM'],
        bookings: ['/booking-history'],
    };
    const openedFrom = new URLSearchParams(path.search).get('from');
    const activeOverride = FROM_MENU_PATHS[openedFrom];

    const isMenuActive = (menuPath) => {
        const normalized = normalize(menuPath);
        // No `from` (a direct link, or navigation from the nav itself) falls
        // through to the original path matching, so every other page is
        // unaffected.
        if (activeOverride) {
            return activeOverride.some((p) => normalize(p) === normalized);
        }
        return currentPath === normalized || currentPath.startsWith(`${normalized}/`);
    };

    useEffect(() => {
        function getheadertitle(name) {
            return sidebarmenus?.find((item) => `/${item?.path}` === name);
        }
        const headername = getheadertitle(path?.pathname);
        headername ? setPageTitle(headername?.name) : setPageTitle('')
    }, [path])

    return (
        <div className='bg-white shadow-cardsection rounded-xl w-full p-5'>
            <div className="flex items-center justify-between">

                {/* Logo */}
                <div className="flex items-center gap-6">
                    {/* Only customer roles get the /home landing; others keep a plain logo. */}
                    {data === "customer" || data === "customer_admin" ? (
                        <NavLink to="/home">
                            <img src={logo} alt="ASAP" className="h-8 cursor-pointer" />
                        </NavLink>
                    ) : (
                        <img src={logo} alt="ASAP" className="h-8" />
                    )}

                    {/* Nav Menu */}
                    <nav className="flex items-center gap-1">
                        {getAuthorizedRoutes.map((menu, index) => {
                            const active = isMenuActive(menu.path);
                            return (
                                <NavLink
                                    key={menu.path || index}
                                    to={menu.path}
                                    // Any top-nav click clears the persisted ocean
                                    // AND air search/query redux so both forms +
                                    // results start fresh (no stale Edit-Query
                                    // prefill) — this is what empties the form on
                                    // "Search Rates". The air form prefills from two
                                    // slices (newsearchform.newsearchformdata and
                                    // newqueries.newqueriesdata); a Queries edit/eye
                                    // seeds them, so both must be reset here or the
                                    // next fresh search opens half-filled with the
                                    // prior query's origin/destination/commodity.
                                    onClick={() => {
                                        dispatch(clearOceanSearchForm());
                                        dispatch(clearStoredSearch());
                                        dispatch(clearnewqueries());
                                    }}
                                    className={`flex items-center gap-2 py-2 px-3 text-sm font-semibold rounded-lg transition-colors
                                        ${active
                                            ? 'text-primary bg-primary/10'
                                            : 'text-secondary hover:bg-gray-100'
                                        }`}
                                >
                                    {/* <img
                                        style={{ width: '18px', height: '18px' }}
                                        src={active ? menu.menuiconActive : menu.menuicon}
                                        alt={menu.name}
                                    /> */}
                                    <span>{menu.name}</span>
                                </NavLink>
                            );
                        })}
                    </nav>

                    {/* Page title (shown when no menu match or as breadcrumb) */}
                    {pageTitle && (
                        <p className='mx-2 font-bold text-lg leading-5 text-secondary'>{pageTitle}</p>
                    )}
                </div>

                {/* Right side actions */}
                <div className="flex items-center gap-2">
                    <HeaderUserName user_name={user_name} />
                    <div className="notificationBell">
                        <NotificationBell />
                    </div>
                    <DropDownButton user_name={user_name} />
                </div>
            </div>
        </div>
    )
}

export default Header
